import { Suspense } from 'react';
import AppLoading from './AppLoading';

export default function AppSuspense(props: any) {
  return (
    <Suspense fallback={<AppLoading delay={0} />}>{props.children}</Suspense>
  );
};